"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module  messages
 * @description This module provides the functionality for messages sent between users.

 * @param  {[type]} config [description]
 * @param  {[type]} get    [description]
 * @param  {[type]} post   [description]
 * @return {function}   read     [description]
 * @return {function}   send     [description]
 * @return {function}   history     [description]
 * @return {function}   latest     [description]
 */
module.exports = function (config, get, post, upload) {

	/**
	 * Gets the latest messages from all contacts
	 * @param  {String} token Session token (optional)
	 * @return {Promise}      Resolves to object of {contactId, content}
	 */
	function latest() {
		return get("/v2/messages/latest", {});
	}

	/**
	 * Gets message history from a contact
	 * @param  {String} token Session token
	 * @param  {String} from  Id of contact to get messages from
	 * @param  {Number} page  The page to load, start from 0
	 * @return {Promise}      Resolves to array of messages if successful
	 */
	function history(from, page) {
		return get("/v2/messages/history", {
			page: page,
			from: from
		});
	}

	/**
	 * Sends a message to a specified user
	 * @param  {String}  token   Session token (optional)
	 * @param  {String}  to      Id of user to send message to
	 * @param  {String}  content Content of the message
	 * @return {Promise}         Resovles if message was sent
	 */
	function send(to, content, popup, patientId, manageGroup) {
		return post("/v2/messages/send", {
			to: to,
			content: content,
			popup: popup,
			patientId: patientId,
			manageGroup: manageGroup
		});
	}

	/**
	 * Sends a message and attachment to a list of specified users
	 * @param  {String}  token   Session token (optional)
	 * @param  {String}  to      Array of Ids of users to send messages to
	 * @param  {String}  content Content of the message
	 * @return {Promise}         Resovles if message was sent
	 */
	 function bulkSend(to, content, file, popup, patientId, manageGroup) {
		if(!file)
			return post("/v2/messages/bulkSend", {
				to: to,
				content: content,
				popup: popup,
				patientId: patientId,
				manageGroup: manageGroup
			});

		return upload("/v2/messages/bulkSend", {
			to: to,
			content: content,
			popup: popup,
			patientId: patientId,
			manageGroup: manageGroup
		}, "file", file);
	}

	/**
	 * Marks messages form a user as read
	 * @param  {String} token Session token (optional)
	 * @param  {String} from  ID of sender to mark as read
	 * @return {Promise}      Resolves if sucessful
	 */
	function read(from) {
		return post("/v2/messages/read", {
			from: from
		});
	}

	function missed() {
		return get("/v2/messages/missed", {});
	}

	function status() {
		return get("/v2/messages/autoreply", {});
	}

	function update(autoreply) {
		return post("/v2/messages/autoreply/update", {
			autoreply: autoreply
		});
	}

	function clear() {
		return post("/v2/messages/autoreply/clear", {});
	}

	function sendFile(file, to, patientId, manageGroup){
		return upload("/v2/messages/send/file", {
			to: to,
			patientId: patientId,
			manageGroup: manageGroup
		}, "file", file);
	}

	return {
		read: read,
		send: {
			message: send,
			bulkMessage: bulkSend,
			file: sendFile
		},
		history: history,
		latest: latest,
		missed: missed,
		autoreply: {
			status: status,
			update: update,
			clear: clear,
		}
	};
};
